var _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHourglassPendingFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_3_626)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3_626",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3_626",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3_626",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFiklEQVR4nO2d3Y9fQxjHp11butUSIaFctFV10XCjaXChJFy1XApVtV4iXZpsiegFLgjRxQ0uSCVo/AWq3NEEW1KtVEhoCKmXiOoLu21paD8y2WmyHed3Zs77PPObz/XMmfnO98zLmfPMOUolEokaIVGIOts+GVIDyZDASIb0uyGNFyiMZEhgJEMCIxkSGF0YMmGVeXHjhQoBuMRqm4k2Cv3UKvSdZIo6ZcY2q212tGHIg+UWgH3JujYMmQXs7lqpAHYCg40bYky5CNjVteKA+Uy3UStmTDNlEBgBxoHJrlsgACZNW6xrrWcUwa6tEg7S9YgXEJse8QJi0yNeQGx6xAuITY94AbHpES8gNj3iBcSmR7yA2PSIFxCbHvECYtMjXkBsesQLiE0PcMLSMFMJBRiwtJxQ0gAOWyLOdaSfpDv+dNTtPCv9QSUN4HtLxFJH+r10xzeOul1hpf9OSQN41xKxxpH+dbpjs6Nua63025Q0gGcsEVsc6VfSHTc56vaWlf5pJQ3gekvEIWB2TvoZwOe0z7hDxxDwh5XnOiV0ZbLfEvKAI881wD8tmvEXcGXBsKfftDYlEWDMEvMLMM+R55GWzDgJ3O2oyzmmztN5VklFRzQCxy1Br5aYf5owY9SjHq9Z+f4G5ivJZPQSzT0e+dY3NHwdAW71KP++jLxye8cpgDnAD5Yw3dCrPfJeBeyp0YztwKUe5a4B/rXy6ueqIRUDwHIzgU5Hb6086ZogmQrIewI4VsGIgyaob4bHQuSpjG0fXfdlKibMw5UtVPMRsNgj/4XAC2bI8eUA8JhrIWGuv9jUxUbX+U4VI3pV08OUo8AGnw1I4AJgo2OrZY9Zrs71uN5MU7aug40etoZVzACrzBBC2d4y7UHyWuA5vRcFfK0nXT3vKE9yegWmjitVPwAsAD7s0RBHfXtLhfLzegWmbgtUP2Hu8Ptztt13AJc3UO4is9rK4pgZDmU+idcBsBB4v+kGwn0DfAwsqUeVcJruLfj1CrFvNBuD/IbT4/1okYYzc8Vozlyhy1rUrKp4estEj0bUp5Qu81w4fJBjbuoVyRBhkIYsMZP6eMVJfWHO8JUm9RKNNRC66eLpqoFo6QYQRdo6CQjgFhOBUmlzsQ4cm4u6jjermAHu7bH93tlQQf7QedIVKSMW4C4jsNNeUfIF1VoVE8DVJmLDvvs2hTSBMtVbNmb0Yl335SoGTJDDvowgh9tUoACrMyJedKDGHCUd80bPZljIfGezSUmmR6DcK0oIwGar7sdFB8oBz1uCftXhmUoIwDzgZ0vDmJIIcAbwuyVmpOYyBoHbzYc59Sf1hoGzai7DDrbeH9JCxBvghowojtk1XXvAhBT9+L9RfqrBdADDmTWVNZRxPG+FkkZGwPSbNV33RuBL3OzzCVf1LDOKAzvvWSLuqHi9uTpyvsfDZR5bq07EOnIxhiNthQ59Oq61IiNguwiHq9wQsRz6LHQsOuc6G2o8lvCSXmyUqIN9LPqQ6rcPBzAVMfIy9bO16OIilg8HnEYJM7bQHNtLmFJaTwyGvEjzvF1k+OpbQ2j3Y/9jTesJhjICgGUZ2/RNopfQq5rSExRFBZitli9on5+As+vWExxFBQCP0h3OocvOoKRRRIB5iXWA7tCxvufXpSdIiggAHqJ7Hq9LT5AUEQB8Rfd8W5eeIPEVoI8WEA5Lq+oJFl8B5kBNKDxcVU+w+Aro+EtyNm9U1RMsvgLMq9dQ2FlVT2eY3+etN++zi3zuIlaOAJ+YrZ9ZbZsxv6PP8Ulhd2u/zTM9I5nhZlcrv88zw1TCj5Eufk5cOYggBpiK0tQ/am7958T2OYr0++6Of999Go0XKIzW2ycZkk8yJDCSIYHRuSGJfJIhgZEMCYxkSL8ZkkiofuI/5i0EPPZZqeIAAAAASUVORK5CYII="
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassPendingFriend);
export default __webpack_public_path__ + "static/media/HourglassPendingFriend.8d4544a1c996208809111f85a70d058f.svg";
export { ForwardRef as ReactComponent };